var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPptx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3905 2.83301H8.99998C8.63178 2.83301 8.33331 3.13147 8.33331 3.49967V29.4997C8.33331 29.8679 8.63178 30.1663 8.99998 30.1663H28.3333C28.7015 30.1663 29 29.8679 29 29.4997V9.44247C29 9.26567 28.9297 9.09611 28.8047 8.97107L22.8619 3.02827C22.7369 2.90324 22.5673 2.83301 22.3905 2.83301Z",
    fill: "white",
    stroke: "#8C7A67",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3646 12.4795C23.0398 12.4795 25.2084 14.6481 25.2084 17.3232H20.3646V12.4795Z",
    fill: "#AB947D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2083 17.9691C25.2083 21.2068 22.4054 23.7898 19.0937 23.4241C16.5766 23.1461 14.5418 21.1113 14.2638 18.5941C13.898 15.2824 16.4811 12.4795 19.7188 12.4795V17.9691H25.2083ZM25.8542 26.042H21.3333H15.8438H11.3229C11.1446 26.042 11 26.1866 11 26.3649C11 26.5433 11.1446 26.6878 11.3229 26.6878H15.8438H21.3333H25.8542C26.0325 26.6878 26.1771 26.5433 26.1771 26.3649C26.1771 26.1866 26.0325 26.042 25.8542 26.042ZM25.8542 24.4274H21.3333H15.8438H11.3229C11.1446 24.4274 11 24.572 11 24.7503C11 24.9287 11.1446 25.0732 11.3229 25.0732H15.8438H21.3333H25.8542C26.0325 25.0732 26.1771 24.9287 26.1771 24.7503C26.1771 24.572 26.0325 24.4274 25.8542 24.4274Z",
    fill: "#D1CCC9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3333 2.83301V8.83301C22.3333 9.20121 22.6318 9.49967 23 9.49967H29",
    stroke: "#8C7A67",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00002 25.1663H14.6667C15.4031 25.1663 16 24.5694 16 23.833V13.1663C16 12.43 15.4031 11.833 14.6667 11.833H4.00002C3.26365 11.833 2.66669 12.43 2.66669 13.1663V23.833C2.66669 24.5694 3.26365 25.1663 4.00002 25.1663Z",
    fill: "#C43E1C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.68205 14.5C10.6364 14.5 11.3675 14.714 11.8745 15.141C12.3818 15.5682 12.6354 16.1871 12.6354 16.9972C12.6354 17.5174 12.5099 17.9799 12.2591 18.3848C12.0084 18.79 11.6516 19.1049 11.1892 19.3297C10.7267 19.5542 10.1906 19.6667 9.58146 19.6667H8.11426V22.5729H6.5V14.5H9.68205ZM8.11429 18.375H9.39517C9.89453 18.375 10.2717 18.2623 10.527 18.0375C10.782 17.8123 10.9094 17.4837 10.9094 17.0514C10.9094 16.2117 10.4207 15.7917 9.44284 15.7917H8.11429V18.375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPptx);
export default __webpack_public_path__ + "static/media/pptx.54d4d493.svg";
export { ForwardRef as ReactComponent };